<label>
  {{ titleInfo.title ?? titleInfo.description }}
  <span appMarkAsterisk [formControlObj]="formControlObj"></span>
  <ng-content select="#header"></ng-content>
  <small *ngIf="titleInfo.hint" class="fst-italic text-primary fw-normal ms-2">{{ titleInfo.hint }}</small>
</label>
<div
  class="my-1 ms-1"
  style="white-space: pre-line"
  *ngIf="titleInfo.title && titleInfo.description"
>
  <small>{{ titleInfo.description }}</small>
</div>
<ng-content></ng-content>
